<template>
  <v-row justify="center">
    <v-col cols="2" xs="2" sm="2" md="2" lg="2" class="icon-area">
      <p>PH</p>
    </v-col>
    <TopParamBase :num-val="phVal" @clickAction="clickAction" />
  </v-row>
</template>

<script>
import TopParamBase from '../Molecules/TopParamBase'

export default {
  name: "TopParamPh",
  data: () => ({}),
  methods: {
    clickAction() {
      this.$emit('clickAction')
    }
  },
  components:{
    TopParamBase
  },
  props:['phVal']
};
</script>

<style scoped>
p {
  margin-bottom: 0;
  padding: 20px 0 0 0;
  color: #fff;
  font-weight: bold;
  font-size: 1.2em;
}
.icon-area {
  padding: 0 12px 0 12px;
}
@media screen and (max-width: 350px) {
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
</style>
